import LockedReplyToEmail from 'Components/LockedReplyToEmail'
import LockedSenderEmail from 'Components/LockedSenderEmail'
import ModalSmsSender from 'Components/ModalSmsSender/ModalSmsSender'
import {
  OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE,
  WORKFLOW_START_TYPE_ACTIVITY,
  WORKFLOW_START_TYPE_EVENT,
  WORKFLOW_START_TYPE_FILTERS,
  WORKFLOW_START_TYPE_GROUP,
  WORKFLOW_START_TYPE_SUBSCRIBER_FIELD,
  WORKFLOW_START_TYPE_SUBSCRIPTION_DATE
} from 'Constants/'

import useTrustedEmailSender from 'Hooks/useTrustedEmailSender'
import {
  trustedSmsSenderState,
  useTrustedSmsSender,
  useTrustedSmsSenderCode
} from 'Hooks/useTrustedSmsSender'

import iconRightCustom from 'Img/flag-red.svg'
import iconRightPreconfigured from 'Img/flag-yellow.svg'
import iconLeftCustom from 'Img/pencil-red.svg'
import iconLeftPreconfigured from 'Img/pencil-yellow.svg'
import Footer from 'Pages/Workflow/components/Step2/Footer'
import StartTypeActivity from 'Pages/Workflow/components/Step2/StartTypeActivity'
import StartTypeEvent from 'Pages/Workflow/components/Step2/StartTypeEvent'
import StartTypeFilters from 'Pages/Workflow/components/Step2/StartTypeFilters'
import StartTypeGroup from 'Pages/Workflow/components/Step2/StartTypeGroup'
import StartTypeSubscriberField from 'Pages/Workflow/components/Step2/StartTypeSubscriberField'
import StartTypeSubscriptionDate from 'Pages/Workflow/components/Step2/StartTypeSubscriptionDate'

import {
  addNewTagCallback,
  resetStepCallback
} from 'Pages/Workflow/recoil/callbacks/callbacks'
import {
  workflowCommonDataState,
  workflowDetails,
  workflowIsPreconfiguredState
} from 'Pages/Workflow/recoil/state/data'
import {
  modalSmsSenderState,
  modalTrustedSmsSenderCodeRequestState
} from 'Pages/Workflow/recoil/state/modals'
import { pageState } from 'Pages/Workflow/recoil/state/page'
import { evalCondition, regexEmail } from 'mailup-react-helpers'
import {
  Flex,
  FormElement,
  Grid,
  GridCell,
  HelpIcon,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
  Panel,
  SELECT_VARIANT_WITH_CHECKBOX,
  SPACING_24,
  Select,
  SpacingVertical,
  TITLE_VARIANT_M,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  Title,
  TooltipUtils,
  TrustedEmailInput,
  TrustedSmsBoxCode,
  TrustedSmsInput,
  toastShow
} from 'mailup-web-components'
import { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState
} from 'recoil'
import { step2State } from '../recoil/state/step2'
import { step3State } from '../recoil/state/step3'
import { ModalTrustedSmsSenderCodeRequest } from './Modals/ModalTrustedSmsSenderCodeRequest'

const WorkflowWizardSecondStep = () => {
  const intl = useIntl()
  const [fieldNameDirty, setFieldNameDirty] = useState(false)

  const isPreconfigured = useRecoilValue(workflowIsPreconfiguredState)
  const { StartType, Type } = useRecoilValue(workflowDetails)

  const { Name, Notes, FromName, FromEmail, ReplyTo, FromSms, Tags } =
    useRecoilValue(step2State)

  const { isPecPlus } = useRecoilValue(pageState)

  const setWorkflowDetails = useSetRecoilState(step2State)

  const addTagCallback = useRecoilCallback(addNewTagCallback, [])
  const { tags: tagsList } = useRecoilValue(workflowCommonDataState)

  const resetStep = useRecoilCallback(resetStepCallback, [])

  useEffect(() => {
    return () => {
      resetStep()
    }
  }, [])

  useEffect(() => {
    TooltipUtils.rebuild()
  })

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const wrongFormatFeedback = intl.formatMessage({
    id: 'Load.TrustedEmailInput.WrongFormatMessage'
  })

  const handleChangeName = useCallback(({ target: { value } }) => {
    setWorkflowDetails((prev) => ({ ...prev, Name: value }))
    setFieldNameDirty(true)
  }, [])

  const handleChangeNotes = useCallback(({ target: { value } }) => {
    setWorkflowDetails((prev) => ({ ...prev, Notes: value }))
  }, [])

  const handleChangeFromName = useCallback(({ target: { value } }) => {
    setWorkflowDetails((prev) => ({ ...prev, FromName: value }))
  }, [])

  const handleChangeReplyTo = useCallback(({ target: { value } }) => {
    setWorkflowDetails((prev) => ({ ...prev, ReplyTo: value }))
  }, [])

  const handleTagsSubmit = (e) => {
    const exist = tagsList.find((t) => t.label === e)
    if (!exist) {
      addTagCallback(e)
    }
  }

  const handleRegisterSuccess = () => {
    toastShow(
      intl.formatMessage({
        id: 'Load.Common.EmailSendMessage'
      }),
      TOAST_VARIANT_SUCCESS
    )
  }

  const handleRegisterError = () => {
    toastShow(
      intl.formatMessage({
        id: 'Load.Common.LoadingDataError'
      }),
      TOAST_VARIANT_ERROR
    )
  }

  const trustedEmailSenderProps = useTrustedEmailSender(
    'workflowEdit',
    true,
    FromEmail,
    handleRegisterSuccess,
    handleRegisterError
  )

  const itemKeyInputSender = 'workflowEditSmsSender'
  // legge la configurazione del workflow per determinare
  // se il campo SMS è obbligatorio
  const { Step } = useRecoilValue(step3State)
  const trustedSmsSenderProps = useTrustedSmsSender(
    itemKeyInputSender,
    Step.filter((e) => e.MessageType === 1).length > 0,
    FromSms
  )
  const handleVerify = (e) => {
    setModalTrustedSmsSenderCodeRequest((prev) => ({
      ...prev,
      show: true
    }))
  }

  const trustedSmsSenderCodeProps = useTrustedSmsSenderCode(
    'workflowEditSmsSenderCode',
    itemKeyInputSender
  )
  const { trustedSmsBoxCodeVisible } = useRecoilValue(
    trustedSmsSenderState('workflowEditSmsSender')
  )

  // Modal TrustedSmsSenderCodeRequest
  const [
    { show: showModalTrustedSmsSenderCodeRequest },
    setModalTrustedSmsSenderCodeRequest
  ] = useRecoilState(modalTrustedSmsSenderCodeRequestState)
  const handleModalTrustedSmsSenderCodeRequestCancel = () => {
    setModalTrustedSmsSenderCodeRequest((prev) => ({
      ...prev,
      show: false
    }))
  }
  const handleModalTrustedSmsSenderCodeRequestConfirm = () => {
    trustedSmsSenderProps.onVerifyClick()
    setModalTrustedSmsSenderCodeRequest((prev) => ({
      ...prev,
      show: false
    }))
  }

  // Modal SmsSender
  const [{ show: showModalSmsSender }, setModalSmsSender] =
    useRecoilState(modalSmsSenderState)
  const handleModalSmsSenderCancel = () => {
    setModalSmsSender((prev) => ({
      ...prev,
      show: false
    }))
  }
  const handleModalSmsSenderConfirm = (event, value) => {
    setModalSmsSender((prev) => ({
      ...prev,
      show: false,
      alias: value.Alias
    }))
  }

  useEffect(() => {
    setWorkflowDetails((prev) => ({
      ...prev,
      FromEmail: trustedEmailSenderProps.value
    }))
  }, [trustedEmailSenderProps.value])

  useEffect(() => {
    setWorkflowDetails((prev) => ({
      ...prev,
      FromSms: trustedSmsSenderProps.value
    }))
  }, [trustedSmsSenderProps.value])

  const validReplyTo = !!ReplyTo && ReplyTo.match(regexEmail)

  const SmsHelp = () => (
    <HelpIcon
      text={intl.formatMessage({
        id: 'Load.TrustedSmsSender.TooltipSmsSender'
      })}
    />
  )

  const getRightBoxTitle = () => {
    switch (Type) {
      case OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE:
      case OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE:
      case OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE:
      case OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE:
        return intl.formatMessage({
          id: 'Load.AutomationWorkflow.PanelTitleEvent'
        })
      case OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE:
      case OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE:
      case OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE:
        return intl.formatMessage({
          id: 'Load.AutomationWorkflow.PanelTitleSubscription'
        })
      case OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE:
        return intl.formatMessage({
          id: 'Load.AutomationWorkflow.PanelTitleWelcomeSeries'
        })
      case OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE:
        return intl.formatMessage({
          id: 'Load.AutomationWorkflow.PanelTitleSubField'
        })
      case OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE:
        return intl.formatMessage({
          id: 'Load.AutomationWorkflow.PanelTitleGroup'
        })
      case OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE:
        return intl.formatMessage({
          id: 'Load.AutomationWorkflow.PanelTitleActivity'
        })
      case OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE:
        return intl.formatMessage({
          id: 'Load.AutomationWorkflow.PanelTitleFilters'
        })
    }
  }

  return (
    <>
      <ModalTrustedSmsSenderCodeRequest
        show={showModalTrustedSmsSenderCodeRequest}
        number={trustedSmsSenderProps.value}
        handleCancel={handleModalTrustedSmsSenderCodeRequestCancel}
        handleConfirm={handleModalTrustedSmsSenderCodeRequestConfirm}
      />
      <ModalSmsSender
        show={showModalSmsSender}
        handleCancel={handleModalSmsSenderCancel}
        handleConfirm={handleModalSmsSenderConfirm}
      />
      <Grid>
        <GridCell span={6}>
          <Panel>
            <Flex flexDirection='column' rowGap='24px'>
              <Flex
                width='100%'
                alignItems='center'
                justifyContent='center'
                flexDirection='column'
                rowGap='8px'
              >
                <img
                  src={isPreconfigured ? iconLeftPreconfigured : iconLeftCustom}
                  width={85}
                  height={85}
                />
                <Title variant={TITLE_VARIANT_M}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleStep2BoxSetup'
                  })}
                </Title>
              </Flex>
              <FormElement
                required
                labelFor='workflowName'
                label={intl.formatMessage({
                  id: 'Load.AutomationWorkflow.WorkflowName'
                })}
                feedback={
                  fieldNameDirty && !Name ? requiredFeedback : undefined
                }
                variant={fieldNameDirty && !Name ? 'danger' : undefined}
              >
                <InputText
                  id='workflowName'
                  autocomplete='new-workflowName'
                  value={Name}
                  onChange={handleChangeName}
                  variant={
                    fieldNameDirty && !Name
                      ? INPUT_TEXT_VARIANT_DANGER
                      : undefined
                  }
                />
              </FormElement>

              <FormElement
                labelFor='workflowNotes'
                label={intl.formatMessage({
                  id: 'Load.AutomationWorkflow.Notes'
                })}
              >
                <InputText
                  id='workflowNotes'
                  autocomplete='new-workflowNotes'
                  value={Notes}
                  onChange={handleChangeNotes}
                />
              </FormElement>

              <FormElement
                required
                labelFor='fromName'
                label={intl.formatMessage({
                  id: 'Load.AutomationWorkflow.FromName'
                })}
                feedback={!FromName ? requiredFeedback : undefined}
                variant={!FromName ? 'danger' : undefined}
              >
                <InputText
                  id='fromName'
                  autocomplete='new-workflowFromName'
                  value={FromName}
                  disabled={evalCondition('uo:EMAILSENDERLOCKED')}
                  onChange={handleChangeFromName}
                  variant={!FromName ? INPUT_TEXT_VARIANT_DANGER : undefined}
                />
              </FormElement>

              {isPecPlus ? (
                <>
                  <LockedSenderEmail value={FromEmail} />
                  <LockedReplyToEmail value={ReplyTo} />
                </>
              ) : (
                <>
                  <FormElement
                    label={intl.formatMessage({
                      id: 'Load.Common.SenderEmailLabel'
                    })}
                    required
                  >
                    <TrustedEmailInput
                      {...trustedEmailSenderProps}
                      disabled={evalCondition('uo:EMAILSENDERLOCKED')}
                    />
                  </FormElement>

                  <FormElement
                    label={intl.formatMessage({
                      id: 'Load.Common.ReplyToEmailLabel'
                    })}
                    required
                    feedback={
                      !ReplyTo
                        ? requiredFeedback
                        : !validReplyTo
                          ? wrongFormatFeedback
                          : undefined
                    }
                    variant={!validReplyTo ? 'danger' : undefined}
                  >
                    <InputText
                      id='replyToEmail'
                      autocomplete='new-workflowReplyTo'
                      value={ReplyTo}
                      disabled={evalCondition('uo:EMAILSENDERLOCKED')}
                      onChange={handleChangeReplyTo}
                      variant={
                        !validReplyTo ? INPUT_TEXT_VARIANT_DANGER : undefined
                      }
                    />
                  </FormElement>
                </>
              )}

              {Type !==
                OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE && (
                <FormElement
                  label={
                    intl.formatMessage({
                      id: 'Load.AutomationWorkflow.SenderSMS'
                    }) +
                    (Step.filter((e) => e.MessageType === 1).length > 0
                      ? ' *'
                      : '')
                  }
                  LabelRightComponent={SmsHelp}
                >
                  <TrustedSmsInput
                    {...trustedSmsSenderProps}
                    onVerifyClick={handleVerify}
                  />
                  {trustedSmsBoxCodeVisible ? (
                    <TrustedSmsBoxCode {...trustedSmsSenderCodeProps} />
                  ) : null}
                </FormElement>
              )}

              <FormElement
                label={intl.formatMessage({
                  id: 'Load.AutomationWorkflow.Tags'
                })}
                hint={intl.formatMessage({
                  id: 'Load.AutomationWorkflow.TagsCaption'
                })}
              >
                <Select
                  variant={SELECT_VARIANT_WITH_CHECKBOX}
                  options={tagsList}
                  multiple
                  value={Tags || []}
                  onSubmit={handleTagsSubmit}
                  data-mu-test='select-tags'
                  placeholder={intl.formatMessage({
                    id: 'Load.TagSelector.lblSelectTags'
                  })}
                  disabled={false}
                  hint={
                    (Tags &&
                      Tags.length === tagsList.length &&
                      intl.formatMessage({
                        id: 'Load.Common.NoMoreOptions'
                      })) ||
                    null
                  }
                  onChange={(value) => {
                    setWorkflowDetails((prev) => ({
                      ...prev,
                      Tags: value
                    }))
                  }}
                />
              </FormElement>
            </Flex>
          </Panel>
        </GridCell>
        <GridCell span={6}>
          <Panel>
            <Flex flexDirection='column' rowGap='24px'>
              <Flex
                width='100%'
                alignItems='center'
                justifyContent='center'
                flexDirection='column'
                rowGap='8px'
              >
                <img
                  src={
                    isPreconfigured ? iconRightPreconfigured : iconRightCustom
                  }
                  width={85}
                  height={85}
                />
                <Title variant={TITLE_VARIANT_M}>{getRightBoxTitle()}</Title>
              </Flex>
              {StartType === WORKFLOW_START_TYPE_EVENT && <StartTypeEvent />}
              {StartType === WORKFLOW_START_TYPE_SUBSCRIPTION_DATE && (
                <StartTypeSubscriptionDate />
              )}
              {StartType === WORKFLOW_START_TYPE_SUBSCRIBER_FIELD && (
                <StartTypeSubscriberField />
              )}
              {StartType === WORKFLOW_START_TYPE_GROUP && <StartTypeGroup />}
              {StartType === WORKFLOW_START_TYPE_ACTIVITY && (
                <StartTypeActivity />
              )}
              {StartType === WORKFLOW_START_TYPE_FILTERS && (
                <StartTypeFilters />
              )}
            </Flex>
          </Panel>
        </GridCell>
      </Grid>
      <SpacingVertical variant={SPACING_24} />
      <Footer />
    </>
  )
}

export default WorkflowWizardSecondStep
